var render, staticRenderFns
import script from "./render-datapoint.vue?vue&type=script&lang=js&"
export * from "./render-datapoint.vue?vue&type=script&lang=js&"
import style0 from "./render-datapoint.vue?vue&type=style&index=0&id=203125b6&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports